var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "70px",
    viewBox: "0 0 24 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WomanArm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3735362,67.3313138 L16.3735362,67.3313138 C14.2044827,67.64413 12.2361946,66.4685789 12,64.7162107 L12.7361398,57.9727316 C12.4999452,56.2173748 12.8316017,57.4248053 15.0045918,57.1109929 C17.1736453,56.7971805 17.2218684,55.0886465 18.4057937,58.3333668 L18.9569144,63.3065457 C19.0287569,63.9530988 19.0169472,64.6116066 18.8742463,65.2501899 C18.6085274,66.4366995 18.080042,67.0842488 16.3735362,67.3313138",
    id: "Fill-24",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.745795,0.130483228 C22.5819317,0.130483228 24,2.97102565 24,8.65211048 C24,14.3331953 19.7813455,22.3728594 11.3440366,32.7711029 C10.3298169,34.92231 10.2067271,37.3228158 11.0001989,39.48307 L17.635861,57.5451677 L13.8719564,59.3817357 L2.16926482,43.3381538 C-2.57732408,37.4524914 1.85696246,27.9359131 2.45410085,26.281293 C2.45410085,26.281293 8.43362283,13.1870764 12.1151285,5.50405031 C15.3887082,-1.32754007 19.745795,0.130483228 19.745795,0.130483228 Z",
    id: "Fill-25",
    fill: "#51DEA0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanArm);
export default __webpack_public_path__ + "static/media/WomanArm.502b6347bc43aa77a3955676b39d65c1.svg";
export { ForwardRef as ReactComponent };